import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SchedulerCrewDto } from '../../api/scheduler/models/scheduler-crew-dto';
import { SchedulerCrewState } from './scheduler-crew.reducer';

export const selectSchedulerCrewState = createFeatureSelector<SchedulerCrewState>('schedulerCrew');

export const selectSchedulerCrewQuery = createSelector(
  selectSchedulerCrewState,
  (state) => state.query
);

export const selectSchedulerCrewLoading = createSelector(
  selectSchedulerCrewState,
  (state) => state.loading
);

export const selectSchedulerCrewAppending = createSelector(
  selectSchedulerCrewState,
  (state) => state.appending
);

export const selectSchedulerCrewLoadMoreError = createSelector(
  selectSchedulerCrewState,
  (state) => state.loadMoreError
);

export const selectSchedulerCrewError = createSelector(
  selectSchedulerCrewState,
  (state) => state.error
);

export const selectSchedulerCrewItems = createSelector(
  selectSchedulerCrewState,
  (state) => state.items
);

export const selectSchedulerCrewVisibleItems = selectSchedulerCrewItems;

export const selectSchedulerCrewPage = createSelector(
  selectSchedulerCrewState,
  (state) => state.page
);

export const selectSchedulerCrewCount = createSelector(
  selectSchedulerCrewPage,
  selectSchedulerCrewVisibleItems,
  (page, items) => page?.totalElements ?? items.length
);

export const selectSchedulerCrewPageNumber = createSelector(
  selectSchedulerCrewPage,
  selectSchedulerCrewQuery,
  (page, query) => page?.page ?? query.page
);

export const selectSchedulerCrewPageSize = createSelector(
  selectSchedulerCrewPage,
  selectSchedulerCrewQuery,
  (page, query) => page?.size ?? query.size
);

export const selectSchedulerCrewTotalPages = createSelector(
  selectSchedulerCrewPage,
  (page) => page?.totalPages ?? (page?.totalElements ? 1 : 0)
);

export const selectSchedulerCrewTotalElements = createSelector(
  selectSchedulerCrewPage,
  selectSchedulerCrewVisibleItems,
  (page, items) => page?.totalElements ?? items.length
);

export const selectSchedulerCrewUpdatingIds = createSelector(
  selectSchedulerCrewState,
  (state) => state.updatingIds
);

export const selectSchedulerCrewCardErrors = createSelector(
  selectSchedulerCrewState,
  (state) => state.cardErrors
);

export const selectSchedulerCrewByCrewId = createSelector(selectSchedulerCrewItems, (items) => {
  const map = new Map<number, SchedulerCrewDto>();
  for (const item of items) {
    map.set(item.crewId, item);
  }
  return map;
});
